module.exports = __webpack_public_path__ + "img/Wp_2077.c8ca3b4e.png";